import { Outlet, useRouteLoaderData } from "@remix-run/react"
import { useTheme } from "remix-themes"
import Footer from "~/components/footer"
import Nav from "~/components/nav"
import { Separator } from "~/components/ui/separator"

export default function Layout() {
  const { user, avatar, notifications, subCredits, bundleCredits, version, env } = useRouteLoaderData("root")
  const [theme, setTheme] = useTheme()

  return (
    <>
      <Nav
        user={user}
        avatar={avatar}
        notificationCount={notifications}
        subCredits={subCredits}
        bundleCredits={bundleCredits}
        theme={theme || undefined}
        setTheme={setTheme}
      />
      <Outlet />
      <Separator className="h-12 sm:h-20 bg-background" />
      <Footer version={version} env={env} />
    </>
  )
}
